import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { OssVatRateSetDefaultCommand, OssVatRateSetDefaultCommandHandlerBase, OssVatRateSetDefaultResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(OssVatRateSetDefaultCommand)
@Injectable({ providedIn: 'root'})
export class OssVatRateSetDefaultCommandHandler {
    private commandHandler: OssVatRateSetDefaultCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new OssVatRateSetDefaultCommandHandlerBase(http);
    }

    public async handleAsync(cmd: OssVatRateSetDefaultCommand): Promise<OssVatRateSetDefaultResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
